import { localize } from '../i18n';
export const INVITE_URL = 'https://pill-reminder.kkomok.com/invite';

export const IOS_STORE_URL = 'https://apps.apple.com/kr/app/%EC%A7%91%EC%9A%94%ED%95%9C%EC%95%BD%EC%95%8C%EB%A6%BC-%EC%95%BD-%EB%B3%B5%EC%9A%A9-%EC%95%8C%EB%A6%BC/id6760472186';

export const ANDROID_STORE_URL = 'https://play.google.com/store/apps/details?id=com.kkomok.pillreminder';

export const getAppInstallText = () => localize("앱 설치:\niOS: {v0}\nAndroid: {v1}", { v0: IOS_STORE_URL, v1: ANDROID_STORE_URL });
